import {createSlice, createAsyncThunk} from "@reduxjs/toolkit";
import {
    ErrorStatusTypes,
    ErrorsStack,
    parseErrorMessage,
} from "../common/errorsDeclarations";

import * as ticketingApi from "../../api/ticketing/ticketingApi";
import {toast} from "react-toastify";
import {DateTime} from "luxon";
import {convertToDateTime} from "../common/dateUtils/convertToDateTime";
import {tokenRefresh} from "../userPreference/userPreferenceSlice";
import {getUtente} from "../authentication/authenticationSlice";

// import { useDispatch } from "react-redux";

export enum StatoTicketTypes {
    BOZZA = 'Bozza',
    APERTO = 'Aperto',
    IN_LAVORAZIONE = 'In lavorazione',
    RISOLTO = 'Risolto',
    CHIUSO = 'Chiuso',
}

export enum PrioritaTicketTypes {
    BASSA = 'Bassa',
    // MEDIUM = 'MEDIUM',
    ALTA = 'Alta',
    CRITICA = 'Critica',
}

export interface Commento {
    id?: number;
    ticket: number;
    autore_id?: number;
    autore_descrizione?: string;
    testo: string;
    created_at: string | DateTime | Date;
    // updated_at: string | DateTime | Date;
    errorsStack?: ErrorsStack;
}

export interface Ticket {
    id: number | null;
    applicativo?: string;
    descrizione?: string;
    autore_id: number;
    autore_descrizione: string;
    autore_email: string;
    owner_id?: number;
    owner_descrizione?: string;
    stato?: string | StatoTicketTypes;
    priorita?: string | PrioritaTicketTypes;
    data_apertura?: string | DateTime | Date | null;
    data_presa_in_carico?: string | DateTime | Date | null;
    data_risoluzione?: string | DateTime | Date | null;
    data_chiusura?: string | DateTime | Date | null;
    commenti?: Commento[]
    errorsStack?: ErrorsStack;
}

export interface TicketsState {
    count: number;
    page: number;
    num_pages: number;
    next?: URL;
    previous?: URL;
    results: Ticket[];
    errorsStack?: ErrorsStack;
}

export interface TicketsStrutturaState {
    tickets: TicketsState;
    conteggioTicketsAttivi?: number;

}

const initialState: TicketsStrutturaState = {
    tickets: {
        count: 0,
        page: 0,
        num_pages: 0,
        next: undefined,
        previous: undefined,
        results: [],
        errorsStack: {status: ErrorStatusTypes.OK},
    },
    conteggioTicketsAttivi: 0
};

export const fetchTickets = createAsyncThunk(
    "ticketing/fetchTickets",
    async (parametri: {
        autore_id?: number;
        owner_id?: number;
        listaStati?: string[];
        priorita?: string;
        numero_record?: number;
        page?: number;
        search?: string;
    }) => {
        return await ticketingApi.fetchTickets(
            parametri.autore_id,
            parametri.owner_id,
            parametri.listaStati,
            parametri.priorita,
            parametri.numero_record,
            parametri.page,
            parametri.search
        );
        //   return user;
    }
);

export const conteggioTicketsAttivi = createAsyncThunk(
    "ticketing/conteggioTaskAttivi",
    async (parametri: {
        autore?: number,
        assegnato_a?: number;
    }) => {
        return await ticketingApi.conteggioTicketsAttivi(
            parametri.autore,
        );
        //   return user;
    }
);

export const saveTicket = createAsyncThunk(
    "ticketing/saveTicket",
    async (parametri: { ticketToSave: Ticket; azione?: string; autore_descrizione?: string}, thunkApi) => {
        return await ticketingApi.saveTicket(parametri.ticketToSave, parametri.azione, parametri.autore_descrizione)
    }
);

export const getTicket = createAsyncThunk(
    "ticketing/getTicket",
    async (ticketId: number, thunkApi) => {
        return await ticketingApi.getTicket(ticketId)
    }
);

export const deleteTicket = createAsyncThunk(
    "ticketing/deleteTicket",
    async (ticketToDelete: Ticket,) => await ticketingApi.deleteTicket(ticketToDelete)
);

// ##############################################################

export const saveCommento = createAsyncThunk(
    "ticketing/saveCommento",
    async (parametri: { ticket: Ticket; commentoToAdd: Commento; azione?: string; }, thunkApi) => {
        // alert('devi ancora fare la action')
        return await ticketingApi.saveCommento(parametri.commentoToAdd, parametri.azione).then((response) => {
            !!parametri.ticket.id && thunkApi.dispatch(getTicket(parametri.ticket.id))
            return response;
        })
    }
);


// export const deleteCommento = createAsyncThunk(
//     "ticketing/deleteCommento",
//     async (commentoToDelete: Commento, thunkApi) => {
//         // alert('devi ancora fare la action')
//         await ticketingApi.deleteCommento(commentoToDelete).then((response) => {
//             thunkApi.dispatch(getTicket(commentoToDelete.ticket))
//             return response;
//         })
//     }
// );


export const ticketingSlice = createSlice({
    name: "ticketingSlice",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        // fetch Tickets
        builder.addCase(fetchTickets.pending, (state) => {
            state.tickets.errorsStack = {status: ErrorStatusTypes.PENDING};
        });
        builder.addCase(fetchTickets.fulfilled, (state, action) => {
            // state.tasks.results = [
            //     ...state.tasks.results.filter(
            //         (task) =>
            //             (!!action.meta.arg.task_id &&
            //                 task.task != action.meta.arg.task_id) ||
            //             (!!action.meta.arg.ordine_id &&
            //                 task.ordine != action.meta.arg.ordine_id)
            //
            //         // (task.ordine != action.meta.arg.ordine_id &&
            //         // 	task.task == (undefined || null)) ||
            //         // task.task != action.meta.arg.task_id
            //     ),
            //     ...action.payload.results,
            // ];

            state.tickets = action.payload

            // state.tasks.results.sort((a, b) => {
            //     const aDate = convertToDateTime(a.scadenza);
            //     const bDate = convertToDateTime(b.scadenza);
            //
            //     if (!aDate) return 1; // Metti i task senza data alla fine
            //     if (!bDate) return -1;
            //     return aDate.toMillis() - bDate.toMillis(); // Ordina per millisecondi
            // });
            state.tickets.results.sort((a, b) => {
                return (b.id || 0) - (a.id || 0);
            });
            state.tickets.errorsStack = {status: ErrorStatusTypes.OK};
        });
        builder.addCase(fetchTickets.rejected, (state, action) => {
            state.tickets.errorsStack = parseErrorMessage(action.error);
        });

        // fetch conteggioTicketsAttivi
        builder.addCase(conteggioTicketsAttivi.pending, (state) => {
            state.tickets.errorsStack = {status: ErrorStatusTypes.PENDING};
        });
        builder.addCase(conteggioTicketsAttivi.fulfilled, (state, action) => {
            state.conteggioTicketsAttivi = action.payload.conteggio_tickets_attivi
            state.tickets.errorsStack = {status: ErrorStatusTypes.OK};
        });
        builder.addCase(conteggioTicketsAttivi.rejected, (state, action) => {
            state.tickets.errorsStack = parseErrorMessage(action.error);
        });

        ////////////////////////////////////////////////////////////////////
        // getTicket
        builder.addCase(getTicket.pending, (state, action) => {
            state.tickets.errorsStack = {
                status: ErrorStatusTypes.PENDING,
            };
        });
        builder.addCase(getTicket.fulfilled, (state, action) => {
            state.tickets.results = state.tickets.results.filter(
                (ticket) => ticket.id != action.payload.id
            );
            state.tickets.results.push(action.payload);
            // state.tasks.results.sort((a, b) => {
            //     const aDate = convertToDateTime(a.scadenza);
            //     const bDate = convertToDateTime(b.scadenza);
            //     if (!aDate) return 1; // Metti i task senza data alla fine
            //     if (!bDate) return -1;
            //     return aDate.toMillis() - bDate.toMillis(); // Ordina per millisecondi
            // });
            state.tickets.results.sort((a, b) => {
                return (b.id || 0) - (a.id || 0);
            });
            state.tickets.errorsStack = {status: ErrorStatusTypes.OK};
        });
        builder.addCase(getTicket.rejected, (state, action) => {
            state.tickets.errorsStack = parseErrorMessage(action.error);
        });


        // save Ticket
        builder.addCase(saveTicket.pending, (state) => {
            state.tickets.errorsStack = {status: ErrorStatusTypes.PENDING};
        });
        builder.addCase(saveTicket.fulfilled, (state, action) => {
            state.tickets.results = state.tickets.results.filter(
                (ticket) => ticket.id != action.payload.id
            );
            state.tickets.results.push({
                ...action.payload,
                errorsStack: {status: ErrorStatusTypes.SUCCESS},
            });

            // state.tasks.results.sort((a, b) => {
            //     const aDate = convertToDateTime(a.scadenza);
            //     const bDate = convertToDateTime(b.scadenza);
            //
            //     if (!aDate) return 1; // Metti i task senza data alla fine
            //     if (!bDate) return -1;
            //     return aDate.toMillis() - bDate.toMillis(); // Ordina per millisecondi
            // });
            state.tickets.results.sort((a, b) => {
                return (b.id || 0) - (a.id || 0);
            });

            state.tickets.errorsStack = {
                status: ErrorStatusTypes.SUCCESS,
            };
        });
        builder.addCase(saveTicket.rejected, (state, action) => {
            state.tickets.errorsStack = parseErrorMessage(action.error);
            toast(`Errore nel salvataggio del ticket`, {type: "error"});
        });

        // delete Ticket
        builder.addCase(deleteTicket.pending, (state, action) => {
            state.tickets.errorsStack = {status: ErrorStatusTypes.PENDING};
        });
        builder.addCase(deleteTicket.fulfilled, (state, action) => {
            state.tickets.results = state.tickets.results.filter(
                (ticket) => ticket.id != action.meta.arg.id
            );
            toast.success(action.payload.message || "Ticket cancellato.");
            state.tickets.errorsStack = {status: ErrorStatusTypes.OK};
        });
        builder.addCase(deleteTicket.rejected, (state, action) => {
            state.tickets.errorsStack = parseErrorMessage(action.error);
        });

        // save Commento


    },
});

// Action creators are generated for each case reducer function
export const {} = ticketingSlice.actions;

export const ticketingSliceReducer = ticketingSlice.reducer;
